module.exports = __webpack_public_path__ + "img/send-email-popup-icon.af20a28c.svg";